import constants from './constants';

const initState = {
  createNewFirmware: {
    id: '',
    version: '',
    fw_url: {},
    fw_crc: '',
  },
  firmwareIdToEdit: null,
};

function firmwareReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_CREATE_EDIT_FIRMWARES:
      return {
        ...state,
        createNewFirmware: payload,
      };

    case constants.SET_FIRMWARES_ID_TO_EDIT:
      return {
        ...state,
        firmwareIdToEdit: payload,
      };

    default:
      return state;

  }

}

export default firmwareReducer;
